// ADV-P0K — platform-wide symbol chart router (single shared launcher).
// Any symbol surface calls openSymbolChart(sym); the App routes to the Markets tab and
// MarketsModule opens the existing StockDetailView/RealStockChart for that symbol. A
// module-level pending value + a ?symbol=&chart=1 query survive the tab-mount race and
// support direct-URL load. No second chart system. Never charts FX (no FX chart provider).
let _pending: string | null = null;

function _norm(s: string): string { return (s || '').trim().toUpperCase(); }

export function isChartableSymbol(symbol: string, assetClass?: string): boolean {
  const s = _norm(symbol);
  if (!s) return false;
  const ac = (assetClass || '').toLowerCase();
  if (ac === 'forex' || ac === 'fx' || ac === 'currency') return false; // no FX chart provider wired
  return true;
}

export function openSymbolChart(symbol: string, opts?: { assetClass?: string }): void {
  const s = _norm(symbol);
  if (!s || !isChartableSymbol(s, opts && opts.assetClass)) return;
  _pending = s;
  try {
    const u = new URL(window.location.href);
    u.searchParams.set('symbol', s);
    u.searchParams.set('chart', '1');
    window.history.replaceState(null, '', u.toString());
  } catch { /* ignore */ }
  try {
    window.dispatchEvent(new CustomEvent('adversyn:symbol-selected', { detail: { value: s, openChart: true } }));
  } catch { /* ignore */ }
}

export function consumePendingChartSymbol(): string | null {
  let s = _pending;
  _pending = null;
  if (!s) {
    try {
      const u = new URL(window.location.href);
      if (u.searchParams.get('chart') === '1') s = _norm(u.searchParams.get('symbol') || '') || null;
    } catch { /* ignore */ }
  }
  return s;
}

export function clearPendingChartSymbol(): void { _pending = null; }

export function clearChartQuery(): void {
  try {
    const u = new URL(window.location.href);
    u.searchParams.delete('symbol');
    u.searchParams.delete('chart');
    window.history.replaceState(null, '', u.toString());
  } catch { /* ignore */ }
}
